"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XYInput = XYInput;
var _react = _interopRequireWildcard(require("react"));
var _reactThemeable = _interopRequireDefault(require("react-themeable"));
var _autokey = require("../autokey");
var _clamp = _interopRequireDefault(require("clamp"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function XYInput(_ref) {
  var children = _ref.children,
    theme = _ref.theme,
    x = _ref.x,
    y = _ref.y,
    xmax = _ref.xmax,
    ymax = _ref.ymax,
    isDark = _ref.isDark,
    disabled = _ref.disabled,
    discRadius = _ref.discRadius,
    onChange = _ref.onChange,
    backgroundColor = _ref.backgroundColor;
  var xyControlContainer = (0, _react.useRef)(null);
  var coords = (0, _react.useRef)({
    start: {
      x: 0,
      y: 0
    },
    offset: {
      x: 0,
      y: 0
    }
  });
  var themer = (0, _autokey.autokey)((0, _reactThemeable["default"])(theme));
  var top = Math.round((0, _clamp["default"])(y / ymax * 100, 0, 100));
  var left = Math.round((0, _clamp["default"])(x / xmax * 100, 0, 100));
  var change = function change(_ref2) {
    var top = _ref2.top,
      left = _ref2.left;
    var _xyControlContainer$c = xyControlContainer.current.getBoundingClientRect(),
      width = _xyControlContainer$c.width,
      height = _xyControlContainer$c.height;
    onChange({
      x: (0, _clamp["default"])(left, 0, width) / width * xmax,
      y: (0, _clamp["default"])(top, 0, height) / height * ymax
    });
  };
  var dragEnd = function dragEnd(e) {
    e.preventDefault();
    document.removeEventListener('mousemove', drag);
    document.removeEventListener('touchmove', drag, {
      passive: false
    });
    document.removeEventListener('mouseup', dragEnd);
    document.removeEventListener('touchend', dragEnd);
    document.removeEventListener('touchcancel', dragEnd);
  };
  var drag = function drag(e) {
    var _coords$current = coords.current,
      start = _coords$current.start,
      offset = _coords$current.offset;
    e.preventDefault();

    // @ts-expect-error checking like this otherwise doesn't work in FF
    var x = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
    // @ts-expect-error checking like this otherwise doesn't work in FF
    var y = e.changedTouches ? e.changedTouches[0].clientY : e.clientY;
    var top = y + start.y - offset.y;
    var left = x + start.x - offset.x;
    change({
      top: top,
      left: left
    });
  };
  var dragStart = function dragStart(e) {
    e.preventDefault();
    var rect = xyControlContainer.current.getBoundingClientRect();
    // @ts-expect-error checking like this otherwise doesn't work in FF
    var x = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
    // @ts-expect-error checking like this otherwise doesn't work in FF
    var y = e.changedTouches ? e.changedTouches[0].clientY : e.clientY;
    var offset = {
      left: x - rect.left,
      top: y - rect.top
    };
    change(offset);
    coords.current = {
      start: {
        x: offset.left,
        y: offset.top
      },
      offset: {
        x: x,
        y: y
      }
    };
    document.addEventListener('mousemove', drag);
    document.addEventListener('mouseup', dragEnd);
    document.addEventListener('touchmove', drag, {
      passive: false
    });
    document.addEventListener('touchend', dragEnd);
    document.addEventListener('touchcancel', dragEnd);
  };
  var themeKeys = ['xyControl'];
  if (isDark) {
    themeKeys.push('xyControlDark');
  }
  if (disabled) {
    themeKeys.push('xyControlDisabled');
  }
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, themer('xyControlContainer'), {
    "data-testid": "xy",
    ref: xyControlContainer,
    onTouchStart: dragStart,
    onMouseDown: dragStart
  }), /*#__PURE__*/_react["default"].createElement("div", _extends({}, themer.apply(void 0, themeKeys), {
    style: {
      backgroundColor: backgroundColor,
      width: "".concat(discRadius, "px"),
      height: "".concat(discRadius, "px"),
      top: "calc(".concat(top, "% - ").concat(discRadius / 2, "px)"),
      left: "calc(".concat(left, "% - ").concat(discRadius / 2, "px)")
    }
  })), children);
}